<template>
  <div>
    <img src="../../assets/wxUser/top.jpg" class="topImg" />
    <div class="word1">商品身份证</div>
    <div class="inputBox">
      <input type="text" v-model="code" class="fwmText" />
      <div class="scanBtn" @click="wxScan()">
        <img src="../../assets/wxUser/wxScan.png" />
      </div>
    </div>
    <div class="checkBtn" v-show="!checkFlag" @click="subCode()">
      验证身份码
    </div>
    <div class="main" v-show="checkFlag">
      <div class="mainTit">查询结果</div>
      <!-- <img :src="img1" v-show="img1 !== ''" class="qrImg1" />
      <img :src="img2" v-show="img2 !== ''" class="qrImg2" />
      <div class="tip" v-show="img1 !== ''">
        注意核对二维码的颜色及图形变化<br />如有不一致请注意假冒产品
      </div> -->
      <div class="checkResult" v-html="fwmResult"></div>
    </div>
    <div class="line1"></div>
    <div class="bottomBox">
      <div class="list" @click="link0()">
        <div>
          <img src="../../assets/wxUser/wxIcon1.png" />
        </div>
        <p>质保登记</p>
      </div>
      <div class="list" @click="link1()">
        <div>
          <img src="../../assets/wxUser/wxIcon2.png" />
        </div>
        <p>企业官网</p>
      </div>
      <div class="list" @click="link2()">
        <div>
          <img src="../../assets/wxUser/wxIcon3.png" />
        </div>
        <p>售后处理中心</p>
      </div>
      <div class="list" @click="showPopup">
        <div>
          <img src="../../assets/wxUser/wxIcon4.png" />
        </div>
        <p>公众号</p>
      </div>
    </div>
    <div class="line2"></div>
    <div class="line3"></div>
    <van-popup v-model="show">
      <img src="../../assets/wxUser/gzh.jpg" class="gzhImg" />
    </van-popup>
  </div>
</template>

<script>
import { Toast, Popup } from "vant";
export default {
  data() {
    return {
      show: false,
      img1: "",
      img2: "",
      code: "",
      checkFlag: false,
      fwmResult: "",
      lng: "",
      lat: "",
    };
  },
  components: {
    [Toast.name]: Toast,
    [Popup.name]: Popup,
  },
  methods: {
    link0() {
      if (this.checkFlag) {
        this.$router.push({
          path: "/WxUser/Order",
          query: { fwm: this.code },
        });
      } else {
        Toast("请先验证防伪码");
      }
    },
    link1() {
      location.href = "http://www.chinaaideli.com/";
    },
    link2() {
      this.$router.push({
        path: "/WxUser/List",
      });
    },
    showPopup() {
      this.show = true;
    },
    getFwmResult() {
      var _this = this;
      this.$post(
        "/api/CodeScan/ProducAntiFake?fCode=" + this.code + "&type=1",
        ""
      )
        .then((re) => {
          if (re.IsSucceed) {
            _this.checkFlag = true;
            _this.fwmResult = re.Content;
            _this.img1 =
              "https://m3a.top/webapi/GetColorQrCode?fwm=" + _this.code;
            _this.img2 = "https://m3a.top/WebApi/GetColorFwm?fwm=" + _this.code;
          } else {
            _this.fwmResult = re.Message;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    subCode() {
      var dd = {
        fCode: this.code,
        fLongitude: this.lng,
        fLatitude: this.lat,
        fQueryType: 1,
        cUrl: window.location.href,
      };
      var _this = this;
      this.$post("/api/CodeScan/CodeScanCheck", dd)
        .then((res) => {
          if (res.IsSucceed) {
            _this.getFwmResult();
          } else {
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    wxScan() {
      var _this = this;
      this.wx.checkJsApi({
        jsApiList: ["scanQRCode"],
        success: function (res) {
          console.log(res);
        },
      });
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          _this.code = result.split("ly_HnwLEAV9_rUb893qF/")[1];
        },
      });
    },
  },
  mounted() {
    // /* global BMap*/
    // const geolocation = new BMap.Geolocation();
    // geolocation.getCurrentPosition(
    //   function (r) {
    //     const point = new BMap.Point(r.point.lng, r.point.lat);
    //     const gc = new BMap.Geocoder();
    //     gc.getLocation(point, function (rs) {
    //       this.lng = rs.point.lng;
    //       this.lat = rs.point.lat;
    //     });
    //   },
    //   { enableHighAccuracy: true }
    // );
  },
  created() {
    var _this = this;
    var dd = {
      url: location.href.split("#")[0],
    };
    this.$get("/WechatOAuthAPI/WechatSign", dd)
      .then((res) => {
        if (!res.IsError) {
          this.wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.Timestamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.Signature,
            jsApiList: ["scanQRCode","getLocation"],
          });
          _this.wx.ready(function () {
            _this.wx.getLocation({
              type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'.
              success: function (res) {
                console.log(res);
                let x_PI = (3.14159265358979324 * 3000.0) / 180.0;
                var lat = Number(res.latitude);
                var lng = Number(res.longitude);
                var z =
                  Math.sqrt(lng * lng + lat * lat) +
                  0.00002 * Math.sin(lat * x_PI);
                var theta =
                  Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
                _this.lng = z * Math.cos(theta) + 0.0065;
                _this.lat = z * Math.sin(theta) + 0.006;

                // let point = new BMap.Point(lng, lat);
                // let gc = new BMap.Geocoder();
                // gc.getLocation(point, function (rs) {
                //   console.log(rs);
                //   let addComp = rs.addressComponents;
                //   _this.LocationProvince = addComp.province;
                //   _this.LocationCity = addComp.city;
                //   _this.LocationArea = addComp.district;
                //   _this.getList();
                // });
              },
              cancel: function () {
                Toast(
                  "您好！由于您拒绝获取地理位置,无法获取相应地区的经销商信息"
                );
              },
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style scoped>
.topImg {
  width: 375px;
}
.qrImg1 {
  width: 110px;
  display: block;
  margin: 0 auto;
}
.qrImg2 {
  width: 180px;
  display: block;
  margin: 0 auto;
  margin-top: 10px;
}
.tip {
  text-align: center;
  font-size: 10px;
  color: #98999a;
  text-align: center;
  margin-top: 10px;
}
.main {
  padding: 20px;
}
.mainTit {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 20px;
}
.word1 {
  font-size: 16px;
  margin-top: 32px;
  margin-bottom: 20px;
}
.inputBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fwmText {
  width: 230px;
  height: 33px;
  border: none;
  border-radius: 10px 0 0 10px;
  border: solid 1px #aaaaaa;
  border-right: none;
  text-indent: 6px;
  font-size: 16px;
}
.scanBtn {
  width: 35px;
  height: 35px;
  background-color: #ff4900;
  border-radius: 0px 10px 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scanBtn img {
  width: 16px;
  height: 16px;
}
.checkBtn {
  width: 117px;
  height: 26px;
  background-color: #ff4900;
  border-radius: 5px;
  line-height: 26px;
  color: white;
  font-size: 14px;
  margin: 15px auto;
}
.checkResult {
  font-size: 13px;
  text-align: left;
  margin-top: 30px;
  font-weight: bold;
}
.line1 {
  background-color: #ff4900;
  height: 15px;
  margin-top: 37px;
  width: 375px;
}
.line2 {
  background-color: #ff4900;
  height: 7px;
  margin: 6px 0;
  width: 375px;
}
.line3 {
  background-color: #ff4900;
  height: 14px;
  width: 375px;
}
.bottomBox {
  display: flex;
  font-size: 14px;
  align-items: center;
  padding: 10px 0;
  justify-content: space-around;
  background: #111111;
  color: white;
}
.list {
  text-align: center;
}
.list p {
  margin-top: 6px;
}
.list div {
  width: 67px;
  height: 67px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.list div img {
  height: 30px;
}
.gzhImg {
  width: 220px;
  height: 220px;
}
</style>
